import {
  GOOGLE_SCOPES,
  DROPBOX_SCOPES,
  SHAREPOINT_SCOPES,
  ONEDRIVE_SCOPES,
  MICROSOFT_365_MAIL_SCOPES,
  ZOHO_SCOPES,
  ZOHO_READ_SCOPES,
  ZOHO_WRITE_SCOPES,
  ZOHO_UPDATE_SCOPES,
  ZOHO_DELETE_SCOPES,
  ZOHO_WORKDRIVE_SCOPES,
  ZOHO_WORKDRIVE_READ_SCOPES,
  ZOHO_WORKDRIVE_CREATE_SCOPES,
  ZOHO_WORKDRIVE_UPDATE_SCOPES,
  ZOHO_WORKDRIVE_DELETE_SCOPES,
  SHAREPOINT_READ_SCOPES,
  SHAREPOINT_CREATE_SCOPES,
  SHAREPOINT_UPDATE_SCOPES,
  SHAREPOINT_DELETE_SCOPES,
} from "./scope";
import {
  ADMIN_API_URL,
  CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME,
  CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME,
} from "./serviceConstant";

export const apiUrlMap = {
  US: "https://www.zohoapis.com",
  EU: "https://www.zohoapis.eu",
  AU: "https://www.zohoapis.com.au",
  IN: "https://www.zohoapis.in",
  China: "https://www.zohoapis.com.cn",
  JP: "https://www.zohoapis.jp",
  SA: "https://www.zohoapis.sa",
  CA: "https://www.zohoapis.ca",
};

export const accountUrlMap = {
  US: "https://accounts.zoho.com",
  AU: "https://accounts.zoho.com.au",
  EU: "https://accounts.zoho.eu",
  IN: "https://accounts.zoho.in",
  China: "https://accounts.zoho.com.cn",
  JP: "https://accounts.zoho.jp",
  SA: "https://accounts.zoho.sa",
  CA: "https://accounts.zohocloud.ca",
};

export const clientIdMap = {
  US: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  AU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  EU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  IN: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  China: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  JP: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  SA: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_ID,
  CA: process.env.REACT_APP_EXTENSION_ZOHO_CANADA_CLIENT_ID,
};

export const clientSecretMap = {
  US: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  AU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  EU: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  IN: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  China: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  JP: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  SA: process.env.REACT_APP_EXTENSION_ZOHO_CLIENT_SECRET,
  CA: process.env.REACT_APP_EXTENSION_ZOHO_CANADA_CLIENT_SECRET,
};

// todo: be carefull about authorizeUrl and accountsUrl. For invitation we use authorizeUrl and for admin we use accountsUrl
export const getAllServiceList = (dataCenter = "US") => {
  return [
    {
      name: "Zoho",
      serviceConnection: process.env.REACT_APP_EXTENSION_IDENTIFIER + "__zoho",
      redirectUrl: ADMIN_API_URL + "/auth/zoho/callback",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl: accountUrlMap[dataCenter] + "/oauth/v2/auth",
      refreshTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      accessTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      revokeUrl: accountUrlMap[dataCenter] + `/oauth/v2/token/revoke`,
      scopes: ZOHO_SCOPES,
      scopeSeperator: ",",
      services: "zoho",
      accountsUrl: accountUrlMap[dataCenter],
      serverAuthUrl: ADMIN_API_URL + "/auth/zoho/authenticate",
      serverVerifyAuth: ADMIN_API_URL + "/auth/zoho/verifyauth",
      serverRevokeUrl: ADMIN_API_URL + "/auth/zoho/revoke",
      serverCallbackUrl: ADMIN_API_URL + "/auth/zoho/callback",
      credentialOfLoginUserApiName: CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME,
      readScopes: ZOHO_READ_SCOPES,
      createScopes: ZOHO_WRITE_SCOPES,
      updateScopes: ZOHO_UPDATE_SCOPES,
      deleteScopes: ZOHO_DELETE_SCOPES,
      description: `Grant access to read and manage CRM records and module fields. This step is mandatory to enable syncing and backing up attachments from Zoho CRM.`,
    },
    {
      name: "Workdrive",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__workdrive",
      redirectUrl: ADMIN_API_URL + "/auth/zoho/callback",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl: accountUrlMap[dataCenter] + "/oauth/v2/auth",
      refreshTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      accessTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      revokeUrl: accountUrlMap[dataCenter] + `/oauth/v2/token/revoke`,
      scopes: ZOHO_WORKDRIVE_SCOPES,
      scopeSeperator: ",",
      services: "drive",
      accountsUrl: accountUrlMap[dataCenter],
      serverAuthUrl: ADMIN_API_URL + "/auth/zoho/authenticate",
      serverVerifyAuth: ADMIN_API_URL + "/auth/zoho/verifyauth",
      serverRevokeUrl: ADMIN_API_URL + "/auth/zoho/revoke",
      serverCallbackUrl: ADMIN_API_URL + "/auth/zoho/callback",
      credentialOfLoginUserApiName: CREDENTIAL_OF_LOGIN_USER_ZOHO_API_NAME,
      readScopes: ZOHO_WORKDRIVE_READ_SCOPES,
      createScopes: ZOHO_WORKDRIVE_CREATE_SCOPES,
      updateScopes: ZOHO_WORKDRIVE_UPDATE_SCOPES,
      deleteScopes: ZOHO_WORKDRIVE_DELETE_SCOPES,
      description: `Grant access to upload and manage files and folders in Zoho Workddrive. This step is mandatory to enable syncing and backing up attachments from Zoho CRM with Zoho Workdrive.`,
    },
    {
      name: "Sharepoint",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__sharepoint",
      redirectUrl: `${ADMIN_API_URL}/auth/sharepoint/callback`,
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl:
        "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
      refreshTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      accessTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      revokeUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${ADMIN_API_URL}/auth/authenticator/callback`,
      scopes: SHAREPOINT_SCOPES,
      scopeSeperator: " ",
      accountsUrl: accountUrlMap[dataCenter],
      serverAuthUrl: ADMIN_API_URL + "/auth/sharepoint/authenticate",
      serverVerifyAuth: ADMIN_API_URL + "/auth/sharepoint/verifyauth",
      serverRevokeUrl: ADMIN_API_URL + "/auth/sharepoint/revoke",
      serverCallbackUrl: ADMIN_API_URL + "/auth/sharepoint/callback",
      services: "drive",
      credentialOfLoginUserApiName: CREDENTIAL_OF_LOGIN_USER_SERVICE_API_NAME,
      readScopes: SHAREPOINT_READ_SCOPES,
      createScopes: SHAREPOINT_CREATE_SCOPES,
      updateScopes: SHAREPOINT_UPDATE_SCOPES,
      deleteScopes: SHAREPOINT_DELETE_SCOPES,
      description: `Grant access to upload and manage files and folders in Microsoft Sharepoint. This step is mandatory to enable syncing and backing up attachments from Zoho CRM with Microsoft Sharepoint.`,
    },
  ];
};

/*
export const getAllServiceList = (dataCenter = "US") => {
  return [
    {
      name: "ZOHO AUTH",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__predefined__zoho",
      redirectUrl: ADMIN_API_URL + "/auth/zoho/callback",
      clientId: clientIdMap[dataCenter],
      clientSecret: clientSecretMap[dataCenter],
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl: accountUrlMap[dataCenter] + "/oauth/v2/auth",
      refreshTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      accessTokenUrl: accountUrlMap[dataCenter] + `/oauth/v2/token`,
      revokeUrl: accountUrlMap[dataCenter] + `/oauth/v2/token/revoke`,
      scopes: ZOHO_AUTH_SCOPES,
      scopeSeperator: ",",
    },
    {
      name: "Google",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__predefined__google",
      redirectUrl: ADMIN_API_URL + "/auth/google/callback",
      clientId:
        "217052741312-ldivpgdh9emoujh3n12d0n4rdcfg04aa.apps.googleusercontent.com",
      clientSecret: "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",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl: "https://accounts.google.com/o/oauth2/v2/auth",
      refreshTokenUrl: `https://accounts.google.com/o/oauth2/token`,
      accessTokenUrl: `https://accounts.google.com/o/oauth2/token`,
      revokeUrl: `https://oauth2.googleapis.com/revoke`,
      scopes: GOOGLE_SCOPES,
      scopeSeperator: " ",
    },
    {
      name: "Dropbox",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__predefined__dropbox",
      redirectUrl: `${ADMIN_API_URL}/auth/dropbox/callback`,
      clientId: "okb3almy4kchvfd",
      clientSecret: "zegzftsjkkgg4fl",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl: "https://www.dropbox.com/oauth2/authorize",
      refreshTokenUrl: `https://api.dropbox.com/oauth2/token`,
      accessTokenUrl: `https://api.dropbox.com/oauth2/token`,
      revokeUrl: `https://api.dropboxapi.com/2/auth/token/revoke`,
      scopes: DROPBOX_SCOPES,
      scopeSeperator: " ",
      queryParams: {
        prompt: "consent",
        token_access_type: "offline",
      },
    },
    {
      name: "Sharepoint",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__predefined__sharepoint",
      redirectUrl: `${ADMIN_API_URL}/auth/sharepoint/callback`,
      clientId: "24601b6c-fb18-450a-b880-cbe064c9ab24",
      clientSecret: "hne8Q~rNk.naWO7EXIkEOB1K9SKjhu5N75KCHadl",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl:
        "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
      refreshTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      accessTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      revokeUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${ADMIN_API_URL}/auth/authenticator/callback`,
      scopes: SHAREPOINT_SCOPES,
      scopeSeperator: " ",
    },
    {
      name: "Onedrive",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER + "__predefined__onedrive",
      redirectUrl: `${ADMIN_API_URL}/auth/onedrive/callback`,
      clientId: "5a658e4f-bf44-483b-84a8-1badcc94d654",
      clientSecret: "cax8Q~lVfDIiJ6ByNevTwcPGoBzaVHErAj5~_bYS",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl:
        "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
      refreshTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      accessTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      revokeUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${ADMIN_API_URL}/auth/authenticator/callback`,
      scopes: ONEDRIVE_SCOPES,
      scopeSeperator: " ",
    },
    {
      name: "Microsoft 365 Mail",
      serviceConnection:
        process.env.REACT_APP_EXTENSION_IDENTIFIER +
        "__predefined__microsoft365mail",
      redirectUrl: `${ADMIN_API_URL}/auth/authenticator/callback`,
      clientId: "24601b6c-fb18-450a-b880-cbe064c9ab24",
      clientSecret: "hne8Q~rNk.naWO7EXIkEOB1K9SKjhu5N75KCHadl",
      crmApiDomain: apiUrlMap[dataCenter],
      authType: "OAuth2",
      authorizeUrl:
        "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
      refreshTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      accessTokenUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/token`,
      revokeUrl: `https://login.microsoftonline.com/common/oauth2/v2.0/logout?post_logout_redirect_uri=${ADMIN_API_URL}/auth/authenticator/callback`,
      scopes: MICROSOFT_365_MAIL_SCOPES,
      scopeSeperator: " ",
    },
  ];
};
*/
// queryParams
// orgId__REACT_APP_EXTENSION_IDENTIFIER__zohoauth__zoho_crm_conn__email@
